/* eslint-disable no-loop-func */
import React from 'react';
import { Box, Tooltip, Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { ChevronRight } from '@kula-ai/icons-core';

interface DepartmentNode {
  id: string;
  name: string;
  parent_id?: string | null;
}

interface DepartmentTreePopoverProps {
  department: DepartmentNode;
  allDepartments: DepartmentNode[];
  children: React.ReactNode;
}

const getNodePath = (option: DepartmentNode, allOptions: DepartmentNode[]) => {
  const path = [];
  let current = option;

  path.unshift(current);

  while (current?.parent_id) {
    const parent = allOptions.find((item) => item.id === current.parent_id);
    if (parent) {
      path.unshift(parent);
      current = parent;
    } else {
      break;
    }
  }

  return path;
};

export const DepartmentTreePopover: React.FC<DepartmentTreePopoverProps> = ({
  department,
  allDepartments,
  children,
}) => {
  const path = getNodePath(department, allDepartments);
  const tooltipLabel = (
    <Flex alignItems="center" gap={1}>
      {path.map((node, index) => (
        <React.Fragment key={node.id}>
          <KText fontSize="sm" color="white">
            {node.name}
          </KText>
          {index < path.length - 1 && <ChevronRight color="white" size={20} />}
        </React.Fragment>
      ))}
    </Flex>
  );

  return (
    <Tooltip
      label={tooltipLabel}
      variant="default"
      placement="top-start"
      maxW="auto"
    >
      <Box display="inline-block">{children}</Box>
    </Tooltip>
  );
};
